"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../../node");
/**
 * Represents a profile enter node.
 *
 * @author Fabien Potencier <fabien@symfony.com>
 */
class TwingProfilerNodeEnterProfile extends node_1.TwingNode {
    constructor(extensionName, type, name, varName) {
        super(new Map(), new Map([['extension_name', extensionName], ['name', name], ['type', type], ['var_name', varName]]));
        this.type = node_1.TwingNodeType.PROFILER_ENTER_PROFILE;
    }
    compile(compiler) {
        compiler
            .write(`let ${this.getAttribute('var_name')} = this.extensions.get(`)
            .repr(this.getAttribute('extension_name'))
            .raw(");\n")
            .write(`let ${this.getAttribute('var_name') + 'Prof'} = new Runtime.TwingProfilerProfile(this.getTemplateName(), `)
            .repr(this.getAttribute('type'))
            .raw(', ')
            .repr(this.getAttribute('name'))
            .raw(');\n')
            .write(`${this.getAttribute('var_name')}.enter(${this.getAttribute('var_name') + 'Prof'});\n\n`);
    }
}
exports.TwingProfilerNodeEnterProfile = TwingProfilerNodeEnterProfile;
